import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalDetail: false,
    data: []
  },

  mutations: {
    TModal(state, value) {
      state.ModalDetail = value
    },

    VData(state, value) {
      state.data = value
    },
  }
})